import { combineReducers } from "redux";
import modalReducer from "~/containers/Modal/services/reducer";
import agentReducer from "./agent/reducer";
import geoReducer from "./geo/reducer";

export default () =>
  combineReducers({
    agent: agentReducer,
    geo: geoReducer,
    modal: modalReducer,
  });
